import React from 'react';

import { translate } from '@vimeo/i18n-runtime';
import { Gear } from '@vimeo/iris/icons';

import { PanelNotification } from '../Styles';

type Props = {
  clipId: number;
};

const DownloadNotice = ({ clipId }: Props) => (
  <PanelNotification>
    <span className="iris_notification-text">
      {translate('Don’t worry! Only you (the creator) can download this video.')}
    </span>
    <a href={`/manage/videos/${clipId}/privacy`}>
      <Gear className="iris_notification-icon iris_ic is--16" />
      <span className="iris_notification-icon-link">{translate('Settings')}</span>
    </a>
  </PanelNotification>
);

export default DownloadNotice;
